export const fragmentMaskShapeQuery = `{
  id
  filename
  url
  width
  height
  svgContent
}`
